// @flow

import * as React from 'react';
import { Query } from 'react-apollo';
import { connect } from 'react-redux';
import Logging from '@ta/common.logging';
import ExternallyConnectedAccountTypesQuery from './ExternallyConnectedAccountTypesQuery.gql';

type ExternalProps = {|
  /** children is a function that accepts a profile render props */
  children: any => React.Node,
|};

type Props = {|
  /** Logged in user id provided by redux */
  loggedInUserId: string,

  ...ExternalProps,
|};

const ExternalAccountTypeDataProvider = ({ children, loggedInUserId }: Props) => (
  <Query
    errorPolicy="all"
    query={ExternallyConnectedAccountTypesQuery}
    variables={{
      loggedInUserId,
    }}
    skip={!loggedInUserId}
  >
    {({ data, error }) => {
      if (data && data.memberProfile) {
        return children(data.memberProfile);
      }
      if (error) {
        // $FlowFixGraphql
        Logging.error(`Error fetching users external account type: ${error}`);
      }
      return null;
    }}
  </Query>
);

export default connect<Props, ExternalProps, _, _, _, _>(state => ({
  loggedInUserId: state.auth.loggedInUserId,
}))(ExternalAccountTypeDataProvider);
